import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2017_28)" }, [
      _createElementVNode("path", {
        fill: "#1E496E",
        d: "M24 12c0 6.612-5.376 12-12 12-6.612 0-12-5.388-12-12C0 5.376 5.388 0 12 0c6.624 0 12 5.376 12 12m-10.73.624c0 .223.071.411.224.564l1.294 1.236.506.47-.576-.035h-7.87c-.436 0-.766.33-.766.788 0 .459.33.8.765.8h7.859l.588-.012-.506.436-1.27 1.247c-.153.164-.247.34-.247.564 0 .448.33.777.776.777.188 0 .4-.094.577-.247l3.035-2.988c.341-.33.318-.824 0-1.142l-3.035-2.988a.9.9 0 0 0-.577-.235c-.459 0-.776.318-.776.765M9.366 4.835 6.318 7.788c-.318.318-.318.87 0 1.177l3.047 2.988c.164.13.376.224.564.224.46 0 .789-.318.789-.765a.74.74 0 0 0-.247-.565L9.2 9.612l-.494-.47.565.034h7.858a.784.784 0 0 0 .789-.8.76.76 0 0 0-.789-.788H9.282l-.564.012.482-.435 1.27-1.247a.76.76 0 0 0 .248-.565c0-.459-.33-.777-.789-.777a.81.81 0 0 0-.564.26"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2017_28" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }